module.exports = __webpack_public_path__ + "assets/colored-812ac1.svg";